<template>
  <LayoutGradient :title="$t('dexpara.material.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaSimpleFilter @search="searchMaterials(true)"/>

        <TableSimple
            :fields="fields"
            :items="materials"
            :loading="DeXParaIsLoading || materialsIsLoading"
            :paginator="pagination"
            :text-empty="$t('dexpara.material.empty')"
            thead-class="h5 text-center"
            @paginate="paginateMaterials"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <b-form-group :label="linha.item.name">
              <b-form-input
                  :id="`input-origem-${linha.index}`"
                  :disabled="!integrationsSelected.origin"
                  v-model="linha.item.origin_code"
                  trim
              />
              <b-button size="sm" variant="link" @click="openLogs(linha);" class="mb-0 p-0" v-if="permissions.includes('logs.detail')">
                {{ $t('dexpara.filtros.logs') }}
              </b-button>
            </b-form-group>
          </template>
          <template v-slot:cell(destination)="{item, index}">
            <b-form-group :label="item.name">
              <b-form-input
                  :id="`input-destino-${index}`"
                  :disabled="!integrationsSelected.destination"
                  v-model="item.destination_code"
                  trim
              />
            </b-form-group>
          </template>
          <template #row-details="{ item, index }">
            <b-card :title="$t('dexpara.log.origem')">
              <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
            </b-card>
            <b-card :title="$t('dexpara.log.destino')" class="mt-2">
              <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
              </b-card-text>
              <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
              <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
            </b-card>
          </template>
        </TableSimple>
      </b-card>

      <DeXParaIntegrationsCopy class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara" @save-copy="(evt) => persistDeXParaCopy(evt)"/>
    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaSimpleFilter from "@/pages/dexpara/components/DeXParaSimpleFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import DeXParaRepository from "@/repositories/dexpara/MaterialRepository";
import {mapActions, mapGetters} from 'vuex';
import TableSimple from "@/components/TableSimple";
import DeXParaIntegrationsCopy from "@/pages/dexpara/components/DeXParaIntegrationsCopy";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaMaterial",
  components: {
    TableSimple,
    DeXParaIntegrationsCopy,
    DeXParaSimpleFilter,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      DeXPara: 'dexpara/material/all',
      DeXParaIsLoading: 'dexpara/material/isLoading',
      materials: 'tuevs/material/all',
      materialsIsLoading: 'tuevs/material/isLoading',
      pagination: 'tuevs/material/pagination',
      filters: 'dexpara/filters',
      specimens: 'tuevs/material/allData',
    }),
  },
  data() {
    return {
      integrationsSelected: {
        origin: null,
        destination: null
      },
      fields: [
        {key: 'origin', label: this.$t('dexpara.material.origem')},
        {key: 'destination', label: this.$t('dexpara.material.destino')}
      ],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'integration/search',
      'dexpara/material/listAll',
      'tuevs/material/listAll',
      'tuevs/material/findAll',
    ]),
    async openLogs(linha) {
      if (linha.detailsShowing === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);
      }      

      linha.toggleDetails();
    },
    async formatLogDetails(specimen) {
      let obj = {}
      let logOrigin = null
      let logDestination = null
      if (!this.DeXPara || this.DeXPara.length === 0) {
        return obj
      }

      let originMapped = this.DeXPara.filter(d => d.tuevs_specimen_id === specimen.id && d.code === specimen.origin_code);
      let destinationMapped = this.DeXPara.filter(d => d.tuevs_specimen_id === specimen.id && d.code === specimen.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].id).then(async (response) => {          
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateMaterials(pagination) {
      await this.$store.commit('tuevs/material/setPagination', {
        ...this.pagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchMaterials()
    },
    async searchMaterials(isFilter = false) {
      if (isFilter) {
        await this.$store.commit('tuevs/material/setPagination', {
          ...this.pagination,
          page: 1
        })
      }

      let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code_mapping");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
        }
      }

      await this['tuevs/material/listAll']({...this.pagination, filters: filterApi})
      await this.searchDeXparas()
      this.loadIntegrationsCodes()
    },
    async searchDeXparas() {
      const filters = [
        ['vns_integration_id', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]
      ]

      if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
        await this['dexpara/material/listAll']({
          per_page: this.pagination.per_page * 50,
          filters: filters
        })
      }
    },
    getMaterialsOfIntegration(integration_id) {
      const materials = this.DeXPara.filter(material => {
        return material.vns_integration_id === integration_id
      })

      if (materials.length > 0) {
        return materials
      }

      return []
    },
    getDeXpara(tuevs_specimen_id, integration_id) {
      if (this.DeXPara && Array.isArray(this.DeXPara)) {
        return this.DeXPara.find(material => {
          return material.vns_integration_id === integration_id && material.tuevs_specimen_id === tuevs_specimen_id
        })
      }
      return null
    },
    loadIntegrationsCodes() {
      if (this.materials && Array.isArray(this.materials)) {
        const materials = this.materials.map(material => {
          const origin_mapped = this.getDeXpara(material.id, this.integrationsSelected.origin)
          material.origin_code = origin_mapped && origin_mapped.code ? origin_mapped.code : null

          const destination_mapped = this.getDeXpara(material.id, this.integrationsSelected.destination)
          material.destination_code = destination_mapped && destination_mapped.code ? destination_mapped.code : null

          return material
        })
        this.$store.commit('tuevs/material/setAll', materials)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected.origin = this.integrationsSelected.destination = null

      let originLabel = this.$t('dexpara.material.origem')
      if (evt.origin) {
        originLabel = evt.origin.label
        this.integrationsSelected.origin = evt.origin.value
      }

      let destinationLabel = this.$t('dexpara.material.destino')
      if (evt.destination) {
        destinationLabel = evt.destination.label
        this.integrationsSelected.destination = evt.destination.value
      }

      this.fields = [{key: 'origin', label: originLabel}, {key: 'destination', label: destinationLabel}]
      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async persistDeXParaCopy(evt) {
      this.copySelected = evt;

      if (this.copySelected.integration_type === null || this.copySelected.integration_to === null) {
          this.$snotify.error(this.$t('dexpara.copia.erro.vazio'))
          return;
      }

      if (this.copySelected.integration_type.value === 'origin' && !this.integrationsSelected.origin) {          
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_origem'))
          return;
      }

      if (this.copySelected.integration_type.value === 'destiny' && !this.integrationsSelected.destination) {
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_destino'))
          return;
      }

      this.$snotify.clear()
      this.$snotify.confirm(
          this.$t('dexpara.copia.confirmacao.mensagem'),
          this.$t('dexpara.copia.confirmacao.titulo'),
          {
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
              {
                text: this.$t('dexpara.copia.sim'),
                action: async toast => {
                  this.$snotify.remove(toast.id)
                  if (this.filters.length > 0) {
                    await this['tuevs/material/findAll']({
                      filters: this.filters
                    })
                  }

                  let filterSpecimens = [
                    ['tuevs_specimen_id', 'IN', this.specimens.reduce((acc, current) => [...acc, current.id], [])]
                  ]

                  await DeXParaRepository.postCopy(
                    {
                      copy: this.copySelected,
                      integrations: this.integrationsSelected,          
                      specimens: filterSpecimens
                    }
                  ).then(async () => {
                    this.$snotify.success(this.$t('dexpara.copia.sucesso'))
                  }).catch(error => {
                    this.$snotify.error(this.$t('dexpara.copia.erro.copiar'))
                  })
                },
                bold: true
              },
              {
                text: this.$t('dexpara.copia.nao'),
                action: toast => {
                  this.$snotify.remove(toast.id)
                },
                bold: true
              }
            ]
          }
      )
    },
    async persistDeXPara() {
      let parsedIntegrations = []

      if (this.integrationsSelected.origin) {
        let integrationId = this.integrationsSelected.origin
        this.materials.filter(c => c.origin_code !== null)
            .map(material => {
              let dexpara = {
                tuevs_specimen_id: material.id,
                integrations: [{id: integrationId, code: material.origin_code}]
              }
              if (this.getDeXpara(material.id, integrationId) && material.origin_code === '') {
                dexpara = {...dexpara, integrations: [integrationId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (this.integrationsSelected.destination) {
        let integrationId = this.integrationsSelected.destination
        this.materials.filter(c => c.destination_code !== null)
            .map(material => {
              let dexpara = {
                tuevs_specimen_id: material.id,
                integrations: [{id: integrationId, code: material.destination_code}]
              }
              if (this.getDeXpara(material.id, integrationId) && material.destination_code === '') {
                dexpara = {...dexpara, integrations: [integrationId], delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (parsedIntegrations.length > 0) {
        await DeXParaRepository.post({specimens: parsedIntegrations}).then(async () => {
          this.$snotify.success(this.$t('dexpara.material.sucesso'))
          await this.searchMaterials()
          await this.searchDeXparas()
        })
      }
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    this.$store.commit('tuevs/material/setPagination', {...this.pagination, page: 1})
    await this['tuevs/material/listAll'](this.pagination)
    await this['integration/search']()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}
</style>
